import { Prop, Component , Fragment, h, Host  } from '@stencil/core';
import { trackAnalyticsEvent } from '../../utils/analytics';

@Component({
  tag: 'ci-accounts',
  styleUrl: 'ci-accounts.scss',
  shadow: true,
})
export class CiAccounts {
  @Prop() isUserLogged: boolean = false;
  @Prop() isSimple: boolean = false;

  renderFullMenu() {
    return (
      <Fragment>
        <a
          href={`${process.env.CI_HOSTNAME}/profiles/designs`}
          class="dialog-action"
          data-section="my account"
          data-link="my designs"
          onClick={trackAnalyticsEvent}
        >
          My Designs
        </a>
        <a
          href={`${process.env.CI_HOSTNAME}/profiles/orders`}
          class="dialog-action"
          data-section="my account"
          data-link="order history"
          onClick={trackAnalyticsEvent}
        >
          Order History
        </a>
        <a
          href={`${process.env.CI_HOSTNAME}/profiles/group_orders`}
          class="dialog-action"
          data-section="my account"
          data-link="group orders"
          onClick={trackAnalyticsEvent}
        >
          Group Orders
        </a>
        <a
          href={`${process.env.CI_HOSTNAME}/fundraising/dashboard`}
          class="dialog-action"
          data-section="my account"
          data-link="fundraisers"
          onClick={trackAnalyticsEvent}
        >
          Fundraisers
        </a>
        <a
          href={`${process.env.CI_HOSTNAME}/profiles/account`}
          class="dialog-action"
          data-section="my account"
          data-link="account settings"
          onClick={trackAnalyticsEvent}
        >
          Account Settings
        </a>
        <a
          href={`${process.env.INVENTORY_HOSTNAME}/account/inventory`}
          class="dialog-action"
          data-section="my account"
          data-link="inventory"
          onClick={trackAnalyticsEvent}
        >
          Inventory
        </a>
      </Fragment>
    );
  }

  renderSimpleMenu() {
    return (
      <a
        href={`${process.env.CI_HOSTNAME}/profiles/account`}
        class="dialog-action"
        data-section="my account"
        data-link="account settings"
        onClick={trackAnalyticsEvent}
      >
        Go to My Account
      </a>
    );
  }

  renderMyAccountMenu() {
    return (
      <Fragment>
        <div slot="dialog-actions" class="dialog-actions">
        {this.isSimple ? this.renderSimpleMenu() : this.renderFullMenu()}
          <hr />
          <a
            href={`${process.env.CI_HOSTNAME}/profiles/users/sign_out`}
            class="ciHeader-account-subMenu-logout dialog-action"
            data-section="my account"
            data-link="sign out"
            data-testid="my-account-logout"
            onClick={trackAnalyticsEvent}
          >
            <svg id="a1767e73-8ad7-4064-8a77-c505c727dc39" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.25 17.93">
              <path
                d="M4.34,8.1A.83.83,0,0,0,3.16,6.92L1.5,8.58a.82.82,0,0,0,0,1.17l1.67,1.68a.83.83,0,0,0,1.18-1.17L4.09,10H8.34a.83.83,0,0,0,.83-.83.84.84,0,0,0-.83-.84H4.1Zm6.49,8.57v1.84a1,1,0,0,0,1.63.91l4.29-2.66a1.66,1.66,0,0,0,.75-1.34V2.91a1.14,1.14,0,0,0-.21-.67.41.41,0,0,0-.05-.09,1.27,1.27,0,0,0-1-.48H7.08A1.25,1.25,0,0,0,5.83,2.91V5a.84.84,0,0,0,.84.83A.83.83,0,0,0,7.5,5V3.33h6.24L11.58,4.67A1.65,1.65,0,0,0,10.83,6v9H7.5V13.33a.83.83,0,0,0-.83-.83.84.84,0,0,0-.84.83v2.09a1.25,1.25,0,0,0,1.25,1.25ZM12.5,6.08,15.83,4v11.4l-3.33,2Z"
                transform="translate(-1.25 -1.67)"
                fill="#4a4a4a"
                fill-rule="evenodd"
              />
            </svg>
            Sign Out
          </a>
        </div>
      </Fragment>

    );
  }

  renderSignInMenu() {
    return (
      <Fragment>
        <span slot='dialog-content' class="ciHeader-account-subMenu-subtitle">Sign in to your account to access saved designs, track orders, and more.</span>
        <div slot="dialog-actions" class="dialog-actions">
          <a
            href={`${process.env.CI_HOSTNAME}/profiles/retrieve`}
            data-section="my account"
            data-link="sign in"
            data-testid="my-account-login"
            onClick={trackAnalyticsEvent}
          >
            Sign In
          </a>
          <a
            href={`${process.env.CI_HOSTNAME}/profiles/users/sign_up`}
            data-section="my account"
            data-link="sign up"
            data-testid="my-account-signup"
            onClick={trackAnalyticsEvent}
          >
            Create An Account
          </a>
        </div>
      </Fragment>
    );
  }
  render() {
    return (
      <Host>
        <ci-dialog
          is-logged-in={this.isUserLogged}
          name={this.isUserLogged ? 'My Account' : 'Sign In'}
        >
          {this.isUserLogged
            ? this.renderMyAccountMenu()
            : this.renderSignInMenu()}
        </ci-dialog>
      </Host>
    );
  }
}
